import { BRANDS } from "@/config/site";
import { Reveal } from "./Motion";

const slug = (n) => n.toLowerCase().replace(/\s+/g, "-");

const BrandCard = ({ b, dup }) => (
  <div
    data-testid={dup ? undefined : `brand-logo-${slug(b.name)}`}
    aria-hidden={dup || undefined}
    className="flex h-24 w-48 sm:h-28 sm:w-56 shrink-0 items-center justify-center rounded-2xl bg-white px-6 shadow-[0_8px_24px_-12px_rgba(15,23,42,0.18)] ring-1 ring-slate-200 transition-transform duration-300 hover:-translate-y-1"
  >
    {b.logo ? (
      <img src={b.logo} alt={dup ? "" : `${b.name} logo`} className={`${b.h || "h-10"} w-auto max-w-full object-contain`} draggable="false" />
    ) : (
      <span className="font-display text-4xl font-extrabold tracking-[0.12em] text-navy-900">{b.name}</span>
    )}
  </div>
);

export const Brands = () => (
  <section data-testid="brands-section" className="relative border-y border-slate-200 bg-cream-100 py-14 sm:py-16">
    <div className="container-x">
      <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-2">
        <h2 className="font-display text-3xl sm:text-4xl font-bold text-navy-900">
          <span className="text-gold-gradient">40+</span> Trusted Brands
        </h2>
        <p className="text-base md:text-lg text-slate-500">Panels · Inverters · Batteries · Electricals</p>
      </Reveal>
    </div>
    <div className="group relative mt-10 overflow-hidden [mask-image:linear-gradient(90deg,transparent,black_8%,black_92%,transparent)]">
      <div data-testid="brands-marquee" className="flex w-max animate-marquee gap-5 py-2 group-hover:[animation-play-state:paused]">
        {[...BRANDS, ...BRANDS].map((b, i) => <BrandCard key={i} b={b} dup={i >= BRANDS.length} />)}
      </div>
    </div>
  </section>
);
